import { IconCornerDownRight } from "@tabler/icons-react";
import { cn } from "../../lib/utils";

type FollowUpQuestionCardProps = {
  question: string;
  className?: string;
  onClick?: () => void;
};

function FollowUpQuestionCard({
  question,
  className,
  onClick,
}: FollowUpQuestionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn("flex items-start gap-3 text-left", className)}
    >
      <IconCornerDownRight className="size-4 shrink-0 text-ds-primary stroke-2" />
      <span className="font-['DM_Sans',sans-serif] font-medium text-ui-body/normal  tracking-[-0.34px] text-ds-primary">
        {question}
      </span>
    </button>
  );
}

export { FollowUpQuestionCard, type FollowUpQuestionCardProps };
